import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useOutsideClick } from "../../../helpers/useOutsideClick";
import { getViewLayout } from "../EditorBox/helpers/getViewLayout";
import LeftArrow from "../../../assets/leftArrow.svg";
import RightArrow from "../../../assets/rightArrow.svg";
import styles from "./Preview.module.css";

const Preview = (props) => {
	const [currSlide, setCurrSlide] = useState(0);

	useEffect(() => {
		document.addEventListener("keyup", handleKeyup);
		return () => {
			document.removeEventListener("keyup", handleKeyup);
		};
	}, [currSlide]);

	const ref = useRef();
	useOutsideClick(ref, props.closePreview);

	const viewLayout = (currSlide) => {
		let slide = props.slideList.slides[currSlide];
		if (slide) {
			return getViewLayout(slide.id, slide.layout, slide.data);
		}
		return null;
	};

	const handlePrev = () => {
		let limit = props.slideList.slides.length - 1;
		if (currSlide > 0 && currSlide <= limit) {
			setCurrSlide(currSlide - 1);
		}
	};

	const handleNext = () => {
		let limit = props.slideList.slides.length - 1;
		if (currSlide >= 0 && currSlide < limit) {
			setCurrSlide(currSlide + 1);
		}
	};

	const handleKeyup = (e) => {
		if (e.keyCode === 27 || e.key === "Escape" || e.code === "Escape") {
			props.closePreview();
		} else if (
			e.keyCode === 39 ||
			e.key === "ArrowRight" ||
			e.code === "ArrowRight"
		) {
			handleNext();
		} else if (
			e.keyCode === 37 ||
			e.key === "ArrowLeft" ||
			e.code === "ArrowLeft"
		) {
			handlePrev();
		}
	};

	return (
		<div ref={ref} className={styles.preview}>
			{viewLayout(currSlide)}

			<img
				className={styles.controlPrev}
				src={LeftArrow}
				alt="Prev"
				onClick={handlePrev}
			/>

			<img
				className={styles.controlNext}
				src={RightArrow}
				alt="Next"
				onClick={handleNext}
			/>
			<p className={styles.slideNumber}>
				{currSlide + 1}/{props.slideList.slides.length}
			</p>
		</div>
	);
};

const mapStateToProps = (state) => ({
	...state,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
